<div class="example_outer_section">
    <div class="example_top_heading">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <h2><span class="OpenSansFonts">Trinka</span>全方位提高写作质量</h2>
                    <p><span class="OpenSansFonts">Trinka</span>旨在帮助学者和技术作者，它不仅检查语法，还满足对有效交流至关重要的高级写作需求。</p>
                </div>
            </div>
        </div>
    </div>

    <div class="exapmle_cards_heading">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <h3>高级语法检查，确保没有书写错误</h3>
                    <p>学术和技术写作会出现其他工具无法捕捉到的特殊写作错误。 <span class="OpenSansFonts">Trinka</span>助您一臂之力！</p>
                </div>
            </div>
        </div>
    </div>

    <div class="example_boxs">
        <div class="container">
            <div class="row">
                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>主语—动词不一致</h4>
                        <p>Therefore, these results suggest that the hypersecretion of CRH and endorphin
                            <span>suppress</span>
                            <span class="right_word">suppresses</span> the secretion of LH and FSH from the pituitary gland.
                        </p>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>选词</h4>
                        <p>The statistical analyses were performed <span>with</span> <span class="right_word">using</span> a statistical analysis software (SAS).</p>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>介词</h4>
                        <p>Recent years have seen an increase <span>of</span> <span class="right_word">in</span> exudation of various organic acids.</p>
                    </div>
                </div>

                <!-- <div class="col-md-12">
                    <div class="example_box_contents">
                        <h4>Subject-verb disagreement</h4>
                        <p><span><span class="OpenSansFonts">Trinka</span></span> is your personal <span>AI editor</span> for all your academic writing
                            needs. <span><span class="OpenSansFonts">Trinka</span></span> is your personal <span>AI editor</span> for all your academic
                            writing needs.</p>
                    </div>
                </div> -->

                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>形容词使用</h4>
                        <p>The group receiving the placebo treatment had the <span>most</span> highest improvement in sleep scores.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- <div class="borderd_line"></div> -->

    <div class="exapmle_cards_heading background_color_changes">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <h3>增强写作至出版标准</h3>
                    <p>通过加强语气、风格和符合标准格式指南，<span class="OpenSansFonts">Trinka</span>能让您的写作更适合学术读者。</p>
                </div>
            </div>
        </div>
    </div>

    <div class="example_boxs boxs_margin background_color_changes">
        <div class="container">
            <div class="row">
                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>简明</h4>
                        <p>Utilities would continue to <span>have the obligation</span> <span class="right_word">be
                                obliged</span> to serve retail customers.</p>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>正式语气</h4>
                        <p>The <span>average</span> <span class="right_word">mean</span> age of the study group was 54.2 years (range: 890 years).</p>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>词语选择</h4>
                        <p>The assembly <span>abrogated</span> <span class="right_word">arrogated</span> to itself the right to make changes.</p>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>风格指南</h4>
                        <p>Substance <span>abuse</span> <span class="right_word">use disorder</span> has been a major public health concern.</p>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <!-- <div class="borderd_line"></div> -->


    <div class="exapmle_cards_heading">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <h3>针对特定专业进行检查并更正</h3>
                    <p><span class="OpenSansFonts">Trinka</span>了解每个学科领域都有其独特的表达方式，能确保更正不会篡改特定学科领域的风格。</p>
                </div>
            </div>
        </div>
    </div>

    <div class="example_boxs boxs_margin">
        <div class="container">
            <div class="row">
                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>计算机科学</h4>
                        <p>In our study, 90% of the users expressed the need for a <span>dialogue</span> <span class="right_word">dialog</span> box to alert them to a pending update.</p>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>物理</h4>
                        <p>By contrast, the <span>effect</span> <span class="right_word">effects</span> of the Mach number and <span class="">heat</span> specific <span class="right_word">heat</span> ratio contribute little to the aerodynamic performance.
                        </p>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>医学</h4>
                        <p>Our study matched for age, <span>gender</span> <span class="right_word">sex</span>, ethnicity, and BMI, marijuana use was associated with higher abdominal visceral fat.
                        </p>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>经济学</h4>
                        <p>The estimated natural rate, based on the <span>past</span> history of the data, plummets by nearly 2
                            <span>percent</span> <span class="right_word">percentage</span> points.
                        </p>
                        <!-- <p>Studies have shown that organizational culture and <span>organizational</span> environment
                            now meet work-life policies.
                        </p> -->
                    </div>
                </div>

            </div>
        </div>
    </div>

    <!-- <div class="borderd_line"></div> -->


</div>